function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M73.359 39.158a5.984 5.984 0 1 1 0-11.953 5.976 5.976 0 0 1 0 11.953zm0-11.01a5.041 5.041 0 1 0 5.053 5.027 4.972 4.972 0 0 0-1.492-3.56 4.921 4.921 0 0 0-3.548-1.467h-.013z",
  fill: "#E4ECFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M73.36 36.06a2.894 2.894 0 1 1-.002-5.789 2.894 2.894 0 0 1 .001 5.788zm0-4.832a1.95 1.95 0 1 0 .002 3.9 1.95 1.95 0 0 0-.003-3.898v-.002zM10.762 39.158a5.984 5.984 0 1 1 0-11.953 5.976 5.976 0 0 1 0 11.953zm0-11.01a5.041 5.041 0 1 0 5.053 5.027 4.97 4.97 0 0 0-1.492-3.56 4.92 4.92 0 0 0-3.548-1.467h-.013z",
  fill: "#E4ECFF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.762 36.06a2.894 2.894 0 1 1-.001-5.79 2.894 2.894 0 0 1 0 5.79zm0-4.832a1.95 1.95 0 1 0 .003 3.9 1.95 1.95 0 0 0-.003-3.898v-.002zM79.826 31.203H83v-.943h-2.454a7.58 7.58 0 0 0-14.505 0H49.5v.943h17.26l.092-.353a6.638 6.638 0 0 1 12.882 0l.092.353z",
  fill: "#E4ECFF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M82.5 30.561v-5.5m-19.5-12 16.009 2.053A4 4 0 0 1 82.5 19.08v.98m-19.5-7v14m0-14C61.53 4.24 58.138 2.624 50 1.621m13 25.44h2.5s2.83-5.5 9.5-5.5c4.5 0 7.5 3.5 7.5 3.5m-19.5 2H50m32.5-2v-5m-32.5 7v-3.5m0 3.5v1m0 2.702v-2.702m32.5-8H80v-2.5h2m-46.5 6v-17c0-7 8.297-5.67 14-5l.5.06m-14.5 21.94H50m-14.5 0h-30l-2.5 2.5v4.5h1s1-5 6.75-5c2.875 0 4.563 1.25 5.531 2.5M50 23.561V1.621m-4 26.44v3.5H25.5l-6-1h-2s-.25-1.25-1.219-2.5m29.719 0h4m-4 0H16.281m35.219-11H56m-55-7h33v12H1v-12zm60 4h-8.5a1 1 0 0 1-1-1V4.887a1 1 0 0 1 1.275-.962l3.608 1.031a4 4 0 0 1 2.738 2.718L61 14.06zm-20.5 0H46a2 2 0 0 0 2-2v-6.5a2 2 0 0 0-2-2h-5.5a2 2 0 0 0-2 2v6.5a2 2 0 0 0 2 2z",
  stroke: "#E4ECFF"
});

var SvgPickup = function SvgPickup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 40,
    viewBox: "0 0 83 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPickup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pickup.44257a4a.svg";
export { ForwardRef as ReactComponent };